import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Plus, Trash2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { VendorDialog } from "./VendorDialog";
import { ConfirmDialog } from "./ConfirmDialog";

export const VendorsTab = () => {
  const { isAdmin } = useAuth();
  const [vendors, setVendors] = useState([]);
  const [editing, setEditing] = useState(null);
  const [deleting, setDeleting] = useState(null);

  const load = useCallback(() => {
    api.get("/vendors").then((r) => setVendors(r.data));
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  const remove = async () => {
    try {
      await api.delete(`/vendors/${deleting.id}`);
      toast.success("Vendor deleted");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setDeleting(null);
  };

  return (
    <div className="space-y-3" data-testid="vendors-tab">
      <button className="btn btn-primary w-full" onClick={() => setEditing({})} data-testid="add-vendor-btn"><Plus size={18} /> Add vendor</button>
      {vendors.length === 0 && <p className="panel p-6 text-center text-muted-foreground">No vendors yet.</p>}
      {vendors.map((v) => (
        <div key={v.id} className="panel flex items-start gap-3 p-4" data-testid={`vendor-row-${v.code}`}>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="mono text-sm font-bold">{v.code}</span>
              {v.is_sample && <span className="chip border-border text-muted-foreground">Sample</span>}
            </div>
            <p className="font-semibold">{v.name}</p>
            <p className="break-words text-xs text-muted-foreground">
              {[v.gstin && `GSTIN ${v.gstin}`, v.location, `${v.payment_days} days`].filter(Boolean).join(" · ")}
            </p>
          </div>
          <button className="icon-btn" onClick={() => setEditing(v)} aria-label="Edit vendor" data-testid={`vendor-edit-${v.code}`}><Pencil size={18} /></button>
          {isAdmin && (
            <button className="icon-btn hover:!text-destructive" onClick={() => setDeleting(v)} aria-label="Delete vendor" data-testid={`vendor-delete-${v.code}`}>
              <Trash2 size={18} />
            </button>
          )}
        </div>
      ))}
      {editing && <VendorDialog vendor={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
      <ConfirmDialog open={!!deleting} onCancel={() => setDeleting(null)} onConfirm={remove}
        title={`Delete ${deleting?.name}?`} body="Existing POs keep their copy of this vendor's details." />
    </div>
  );
};
